module.exports = __webpack_public_path__ + "img/icon_work_02.5f744fbc.png";